webpackJsonp([166],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(365);

var _vuex2 = _interopRequireDefault(_vuex);

var _util = __webpack_require__(192);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: {
    userInfo: null,
    loading: false,
    isCollapse: false,
    logoShow: false,
    uniquerouter: true,
    menus: [],
    rightNav: {},
    noMenuPages: [{ path: '/dashboard', title: '首页' }, { path: '/user/profile', title: '个人信息' }, { path: '/user/changepwd', title: '修改密码' }, { path: '/RegulatorWorkTask', title: '工作任务' }, { path: '/RegulatorTrainTask', title: '培训任务' }, { path: '/RegulatorPotentialTask', title: '隐患排查任务' }, { path: '/RegulatorSafetyMeetingTask', title: '安全例会任务' }, { path: '/Mail', title: '待办事项' }, { path: '/UserRewardsPunishmentRecord', title: '奖惩记录' }, { path: '/UserHomeVisitRecord', title: '家访记录' }],
    tabnavBox: [{
      title: '首页',
      path: '/dashboard'
    }]
  },
  mutations: {
    addTab: function addTab(state, arg) {
      for (var i = 0; i < state.tabnavBox.length; i++) {
        if (state.tabnavBox[i].path === arg.path) {
          return false;
        }
      }
      var path = '/' + arg.path.replace('/', '');
      var menus = _util2.default.expandMenusData();
      if (menus.includes(path)) {
        state.tabnavBox.push({
          title: arg.title,
          path: path
        });
      }
    },
    openMenu: function openMenu(state, arg) {
      state.rightNav = arg;
    },
    removeTab: function removeTab(state, arg) {
      var index = state.tabnavBox.findIndex(function (value, key) {
        return value.path === arg.tabItem.path;
      });
      state.tabnavBox.splice(index, 1);
      if (arg.tabItem.path === arg.fullPath) {
        var tabActive = state.tabnavBox[index] || state.tabnavBox[index - 1];
        arg.router.push(tabActive.path);
      }
    },
    removeOtherTab: function removeOtherTab(state, arg) {
      state.tabnavBox = [{
        title: '首页',
        path: '/dashboard'
      }];
      if (arg.all) {
        arg.router.push('/dashboard');
        return false;
      }
      state.tabnavBox.push(arg.tabItem);
      arg.router.push(arg.tabItem.path);
    },
    collapse: function collapse(state, arg) {
      state.isCollapse = !state.isCollapse;
      if (state.logoShow) {
        setTimeout(function () {
          state.logoShow = false;
        }, 300);
      } else {
        state.logoShow = true;
      }
    }
  },
  actions: {
    addTab: function addTab(_ref, arg) {
      var commit = _ref.commit;

      commit('addTab', arg);
    },
    openMenu: function openMenu(_ref2, arg) {
      var commit = _ref2.commit;

      commit('openMenu', arg);
    },
    removeTab: function removeTab(_ref3, arg) {
      var commit = _ref3.commit;

      commit('removeTab', arg);
    },
    removeOtherTab: function removeOtherTab(_ref4, arg) {
      var commit = _ref4.commit;

      commit('removeOtherTab', arg);
    },
    collapse: function collapse(_ref5, arg) {
      var commit = _ref5.commit;

      commit('collapse', arg);
    }
  }
});

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(193);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = __webpack_require__(360);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _qs = __webpack_require__(352);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
    var l = len - (s + '').length;
    for (var i = 0; i < l; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    scrollTop: function scrollTop(callback) {
        var totalH = document.body.scrollHeight || document.documentElement.scrollHeight;

        var clientH = window.innerHeight || document.documentElement.clientHeight;
        var result = {};
        window.addEventListener('scroll', function (e) {
            var validH = totalH - clientH;

            var scrollH = document.body.scrollTop || document.documentElement.scrollTop;

            result.percentage = (scrollH / validH * 100).toFixed(2);
            result.scrollH = scrollH;
            callback && callback(result);
        });
    },

    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        var context = '';
        if (r != null) {
            context = r[2];
        }
        reg = null;
        r = null;
        return context === null || context === '' || context === 'undefined' ? '' : context;
    },
    getSubUrl: function getSubUrl() {
        var url = window.location.href;
        var subUrl = url.substr(8, 4);
        return subUrl;
    },
    getOssKey: function getOssKey(enterpriseName, type, file) {
        var key = "";
        key = key + type + "/";
        key += enterpriseName + "/";
        var nowDate = new Date();
        key = key + nowDate.getFullYear();
        key = key + "-" + (nowDate.getMonth() + 1);
        key = key + "-" + nowDate.getDate();
        key = key + "/" + nowDate.getTime() + file.name;
        return key;
    },
    dateFormat: function dateFormat(examSecond) {
        var result = parseInt(examSecond);
        var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
        var m = Math.floor(result / 60 % 60) < 10 ? '0' + Math.floor(result / 60 % 60) : Math.floor(result / 60 % 60);
        var s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60);
        var res = '';
        if (h !== '00') res += h + '\u65F6';
        if (m !== '00') res += m + '\u5206';
        res += s + '\u79D2';
        return res;
    },

    formatDate: {
        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        format1: function format1(date, pattern) {
            if (typeof date == 'string') {
                date = new Date(date);
            }
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length === matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);
                            break;
                        case 'M':
                            _date.setMonth(_int - 1);
                            break;
                        case 'd':
                            _date.setDate(_int);
                            break;
                        case 'h':
                            _date.setHours(_int);
                            break;
                        case 'm':
                            _date.setMinutes(_int);
                            break;
                        case 's':
                            _date.setSeconds(_int);
                            break;
                    }
                }
                return _date;
            }
            return null;
        }

    },
    change_size: function change_size(filesize) {
        var size = "";
        if (filesize < 0.1 * 1024) {
            size = filesize.toFixed(2) + "B";
        } else if (filesize < 0.1 * 1024 * 1024) {
            size = (filesize / 1024).toFixed(2) + "KB";
        } else if (filesize < 0.1 * 1024 * 1024 * 1024) {
            size = (filesize / (1024 * 1024)).toFixed(2) + "MB";
        } else {
            size = (filesize / (1024 * 1024 * 1024)).toFixed(2) + "GB";
        }
        var sizeStr = size + "";
        var index = sizeStr.indexOf(".");
        var dou = sizeStr.substr(index + 1, 2);
        if (dou == "00") {
            return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
        }
        return size;
    },
    expandMenusData: function expandMenusData() {
        var menus = _qs2.default.parse(localStorage.getItem('menus'));
        var list = [{
            url: '/dashboard',
            text: '首页'
        }, {
            url: '/401',
            text: '无权限'
        }, {
            url: '/404',
            text: '无页面'
        }, {
            url: '/RegulatorWorkTask',
            text: '工作任务'
        }, {
            url: '/RegulatorTrainTask',
            text: '培训任务'
        }, {
            url: '/RegulatorPotentialTask',
            text: '隐患排查任务'
        }, {
            url: '/RegulatorSafetyMeetingTask',
            text: '安全例会任务'
        }, {
            url: '/Mail',
            text: '待办事项'
        }, {
            url: '/SafetyMeasures',
            text: '安全措施'
        }, {
            url: '/ProcessInspection',
            text: '过程检查表'
        }, {
            url: '/JobFlow',
            text: '作业流程'
        }, {
            url: '/ViewDetails',
            text: '查看记录'
        }];
        function getChildrenList(item) {
            var list = [];
            if (item.children && item.children.length) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(item.children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _item = _step.value;

                        list.push.apply(list, (0, _toConsumableArray3.default)(getChildrenList(_item)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else if (item.url) {
                item.url = '/' + item.url.replace('/', '');
                list.push(item);
            }
            return list;
        }
        for (var key in menus) {
            var item = menus[key];
            list.push.apply(list, (0, _toConsumableArray3.default)(getChildrenList(item)));
        }
        return list.map(function (item) {
            return item.url;
        });
    }
};

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_unfold_vue__ = __webpack_require__(215);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71317902_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_unfold_vue__ = __webpack_require__(750);
function injectStyle (ssrContext) {
  __webpack_require__(727)
}
var normalizeComponent = __webpack_require__(94)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71317902"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_unfold_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71317902_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_unfold_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);






function getMediaDuration(fileUrl) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var audioElement = new Audio(fileUrl);
        audioElement.addEventListener("loadedmetadata", function (_event) {
            var duration = parseInt(audioElement.duration);
            resolve(duration);
        });
    });
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "custom-upload",
    inheritAttrs: false,
    props: {
        fileList: {
            type: [Array, null],
            default: function _default() {
                return [];
            }
        },
        onlyUpload: Boolean
    },
    data: function data() {
        return {
            preview_url: "",
            fileShow: false,
            preview_visible: false,
            document_suffix: ".txt,.doc,.docx,.xls,.xlsx,.pdf",
            image_suffix: ".jpg,.png,.gif,.bmp",
            all_suffix: ".txt,.doc,.xls,.ppt,.pdf,.jpg,.png,.gif,.bmp,.docx,.xlsx,.pptx,.mp4,.avi,.mov"
        };
    },

    methods: {
        url: function url() {
            var API_UPLOAD_URL = "https://upload.gghs.info/upload/";
            return API_UPLOAD_URL;
        },
        before: function before() {
            return false;
        },
        before_remove: function before_remove(file) {
            var that = this;
            if (file && file.status === "success") {
                return this.$confirm("\u786E\u5B9A\u79FB\u9664 " + file.name + "\uFF1F", "提示", {}).then(function () {
                    that.remove(file);
                    return reject(false);
                }, function () {
                    reject(false);
                });
            }
        },
        remove: function remove(file) {
            if (file && file.status === "success") {
                var index = this.fileList.findIndex(function (item) {
                    return file.url == item.url;
                });
                this.fileList.splice(index, 1);
            }
            return false;
        },
        change: function change(file) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var that, loading, formData, config, res, _fileList, i, item;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                that = _this;
                                loading = _this.$loading({
                                    lock: true,
                                    text: "上传中...",
                                    spinner: "el-icon-loading",
                                    background: "rgba(0, 0, 0, 0.7)"
                                });

                                if (!(file && file.status === "ready")) {
                                    _context.next = 34;
                                    break;
                                }

                                formData = new FormData();

                                formData.set("file", file.raw);
                                _context.prev = 5;
                                config = {
                                    headers: {
                                        "Content-type": "multipart/form-data"
                                    }
                                };
                                _context.next = 9;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(that.url(), formData, config);

                            case 9:
                                res = _context.sent;

                                if (!(res.status == 200 && res.data.status == 2000)) {
                                    _context.next = 28;
                                    break;
                                }

                                if (!res.data.errors.length) {
                                    _context.next = 15;
                                    break;
                                }

                                _this.$message.error("上传失败," + res.data.errors[0].error);
                                _context.next = 28;
                                break;

                            case 15:
                                i = 0;

                            case 16:
                                if (!(i < res.data.files.length)) {
                                    _context.next = 25;
                                    break;
                                }

                                item = res.data.files[i];

                                if (!/mp3|mp4/.test(item.ext)) {
                                    _context.next = 22;
                                    break;
                                }

                                _context.next = 21;
                                return getMediaDuration(item.url);

                            case 21:
                                item.duration = _context.sent;

                            case 22:
                                i++;
                                _context.next = 16;
                                break;

                            case 25:
                                (_fileList = _this.fileList).push.apply(_fileList, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res.data.files));
                                _this.$emit('change', _this.fileList);
                                if (_this.onlyUpload) {
                                    _this.fileList.splice(0, 1);
                                }

                            case 28:
                                _context.next = 33;
                                break;

                            case 30:
                                _context.prev = 30;
                                _context.t0 = _context["catch"](5);

                                _this.$message.error("网络异常，请稍后重试");

                            case 33:
                                loading.close();

                            case 34:
                                return _context.abrupt("return", false);

                            case 35:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[5, 30]]);
            }))();
        },
        preview: function preview(file) {
            window.open(file.viewurl);
            this.fileShow = true;
            this.preview_url = file.url;
            this.preview_visible = true;
        }
    }
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            mediaType: 'mp4',
            src: '',
            visible: false
        };
    },

    computed: {
        title: function title() {
            return this.mediaType === 'mp4' ? '视频预览' : '音频预览';
        }
    },
    watch: {
        visible: function visible(val) {
            if (!val) {
                this.src = '';
            }
        }
    },
    methods: {
        show: function show(src, type) {
            var _this = this;

            this.visible = true;
            this.src = src;
            this.mediaType = type;
            if (!/mp4|mp3/.test(type)) {
                this.mediaType = 'mp4';
            }
            this.$nextTick(function () {
                _this.$refs.playVideo.play();
            });
        },
        VideoClose: function VideoClose() {
            this.visible = false;
        }
    }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "unfold",
  data: function data() {
    return {
      showBtn: true
    };
  },

  props: {
    tip: {
      type: String,
      default: '全文'
    },

    data: {
      type: String,
      default: ''
    },

    maxLen: {
      type: Number,
      default: 80
    }
  },
  computed: {
    sliceStr: function sliceStr() {
      if (this.data != null) {
        return this.data.substring(0, this.maxLen) + "...";
      }
      return '';
    }
  }
});

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  apiServer: {
    Admin: "/api-admin",
    Base: "/api-base",
    CMS: "/api-cms",
    Activiti: "/api-activiti",
    Zuul: "/zuul" },

  dictionary: {
    DANGEROUS_OPERATION_TYPE: "DANGEROUS_OPERATION_TYPE",
    STANDARD_LEVEL: "STANDARD_LEVEL",
    ENTERPRISE_CATEGORY: "ENTERPRISE_CATEGORY",
    OPERATION_FORM: "OPERATION_FORM" },

  type_dictionary: {
    OPERATING_PROCEDURES: '92793b134d4f442b9b1e0782917e395a'
  },

  HotWork: {
    LGNITION_TASK: 'LgnitionTask',
    SIGN_IMG: 'signImg',
    SCENE_IMG: "sceneImg",
    PRELIMINARY_IMG: "preliminaryImg",
    ON_SITE_IMG: "onSiteImg",
    WORK_IMG: 'workImg',
    WHEN_HOT_SIGN_IMG: 'whenHotSignImg',
    WHEN_HOT_SCENE_IMG: 'whenHotSceneImg',
    ACCEPTANCE_SIGN_IMG: 'acceptanceSignImg',
    ACCEPTANCE_SCENE_IMG: 'acceptanceSceneImg',
    Type: {
      FIRE_NAME: 'FIRE',
      BLIND_NAME: 'BLIND',
      GROUND_NAME: 'GROUND',
      LIFT_NAME: 'LIFT',
      LIMIT_NAME: 'LIMIT',
      TEMP_NAME: 'TEMP',
      HIGH_NAME: 'HIGH',
      BROKEN_NAME: 'BROKEN' }
  },

  HotWorkRole: {
    ON_SITE: 37,
    ACCEPTANCE: 38 },
  SystemInitRole: {
    EnterpriseAdmin: 45,
    SubEnterpriseAdmin: 46 },

  Activiti: 'activiti',
  FIRE_ACTION: "https://portapi.gghs.info/" + '/api-activiti/task/createAttachment',

  RelevantExamineResultImpotUrl: "https://portapi.gghs.info/" + '/api-cms/RelevantExamineResult/importData'
};

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(751);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _util = __webpack_require__(192);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Home = function Home() {
  return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 870));
};
var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 825));
};
var schoolDashboard = function schoolDashboard() {
  return __webpack_require__.e/* import() */(119).then(__webpack_require__.bind(null, 940));
};
var notFound = function notFound() {
  return __webpack_require__.e/* import() */(152).then(__webpack_require__.bind(null, 926));
};
var notPermission = function notPermission() {
  return __webpack_require__.e/* import() */(154).then(__webpack_require__.bind(null, 925));
};
var PotentialCheckTable = function PotentialCheckTable() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 812));
};
var PotentialCheckPlan = function PotentialCheckPlan() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 810));
};
var PotentialExaminationPre = function PotentialExaminationPre() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 814));
};
var PotentialAssignmentPre = function PotentialAssignmentPre() {
  return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 889));
};
var PotentialApplyCancelPre = function PotentialApplyCancelPre() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 813));
};

var PotentialRectificationPre = function PotentialRectificationPre() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 817));
};
var PotentialFilePre = function PotentialFilePre() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 815));
};
var potentialCheckRecord = function potentialCheckRecord() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 811));
};
var RegulatorPotentialTask = function RegulatorPotentialTask() {
  return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 886));
};
var RegulatorSafetyMeetingTask = function RegulatorSafetyMeetingTask() {
  return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 883));
};
var RegulatorWorkTask = function RegulatorWorkTask() {
  return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 914));
};

var Sms = function Sms() {
  return __webpack_require__.e/* import() */(146).then(__webpack_require__.bind(null, 898));
};

var PreExpirationConfig = function PreExpirationConfig() {
  return __webpack_require__.e/* import() */(147).then(__webpack_require__.bind(null, 892));
};

var Integralset = function Integralset() {
  return __webpack_require__.e/* import() */(149).then(__webpack_require__.bind(null, 872));
};
var Integralist = function Integralist() {
  return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 871));
};

var organList = function organList() {
  return __webpack_require__.e/* import() */(121).then(__webpack_require__.bind(null, 860));
};
var postList = function postList() {
  return __webpack_require__.e/* import() */(120).then(__webpack_require__.bind(null, 861));
};

var EnterpriseInfo = function EnterpriseInfo() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 838));
};
var EnterpriseData = function EnterpriseData() {
  return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 837));
};
var ServiceUnit = function ServiceUnit() {
  return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 851));
};
var SchoolVehicle = function SchoolVehicle() {
  return __webpack_require__.e/* import() */(131).then(__webpack_require__.bind(null, 847));
};
var SchoolVehicleInsurance = function SchoolVehicleInsurance() {
  return __webpack_require__.e/* import() */(130).then(__webpack_require__.bind(null, 848));
};
var SchoolVideoMonitor = function SchoolVideoMonitor() {
  return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 850));
};
var SchoolVehicleRepairRecord = function SchoolVehicleRepairRecord() {
  return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 849));
};

var UserRewardsPunishmentRecord = function UserRewardsPunishmentRecord() {
  return __webpack_require__.e/* import() */(129).then(__webpack_require__.bind(null, 858));
};
var UserHomeVisitRecord = function UserHomeVisitRecord() {
  return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 857));
};

var Driver = function Driver() {
  return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 836));
};

var Stevedore = function Stevedore() {
  return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 855));
};

var Escort = function Escort() {
  return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 839));
};

var SafetyInput = function SafetyInput() {
  return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 843));
};

var SafetyPerson = function SafetyPerson() {
  return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 845));
};

var MonitorPerson = function MonitorPerson() {
  return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 840));
};

var NetworkDocumen = function NetworkDocumen() {
  return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 841));
};

var Vehicle = function Vehicle() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 859));
};

var SafetyMeeting = function SafetyMeeting() {
  return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 844));
};

var SafetyTrained = function SafetyTrained() {
  return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 846));
};

var Accident = function Accident() {
  return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 835));
};

var SpecialPersonnel = function SpecialPersonnel() {
  return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 854));
};

var SpecialEquipment = function SpecialEquipment() {
  return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 853));
};

var User = function User() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 856));
};

var FileSign = function FileSign() {
  return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 868));
};

var PreMeetingSign = function PreMeetingSign() {
  return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 842));
};

var Document = function Document() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 826));
};

var RiskUnit = function RiskUnit() {
  return __webpack_require__.e/* import() */(116).then(__webpack_require__.bind(null, 895));
};

var RiskEvent = function RiskEvent() {
  return __webpack_require__.e/* import() */(117).then(__webpack_require__.bind(null, 894));
};

var RiskControl = function RiskControl() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 819));
};

var Inspection = function Inspection() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 818));
};

var Notices = function Notices() {
  return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 913));
};

var Mail = function Mail() {
  return __webpack_require__.e/* import() */(135).then(__webpack_require__.bind(null, 912));
};

var Password = function Password() {
  return __webpack_require__.e/* import() */(132).then(__webpack_require__.bind(null, 792));
};

var UserInfo = function UserInfo() {
  return __webpack_require__.e/* import() */(134).then(__webpack_require__.bind(null, 793));
};

var violationList = function violationList() {
  return __webpack_require__.e/* import() */(151).then(__webpack_require__.bind(null, 917));
};

var accidentcases = function accidentcases() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 820));
};
var Study = function Study() {
  return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 911));
};
var technicalnorm = function technicalnorm() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 822));
};
var law = function law() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 821));
};
var studyManagement = function studyManagement() {
  return __webpack_require__.e/* import() */(158).then(__webpack_require__.bind(null, 910));
};

var reservePlan = function reservePlan() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 802));
};
var troops = function troops() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 803));
};
var material = function material() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 801));
};
var drill = function drill() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 800));
};
var emergencyManagement = function emergencyManagement() {
  return __webpack_require__.e/* import() */(163).then(__webpack_require__.bind(null, 834));
};

var MeetTable = function MeetTable() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 882));
};
var potentialCheck = function potentialCheck() {
  return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 887));
};

var potentialReview = function potentialReview() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 823));
};
var potentialRecord = function potentialRecord() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 816));
};
var potentialDangerRecord = function potentialDangerRecord() {
  return __webpack_require__.e/* import() */(153).then(__webpack_require__.bind(null, 888));
};
var Logbook = function Logbook() {
  return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 878));
};
var MonthSafelyCheck = function MonthSafelyCheck() {
  return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 884));
};
var Assess = function Assess() {
  return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 824));
};
var VehicleWarn = function VehicleWarn() {
  return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, 916));
};
var VehicleLocation = function VehicleLocation() {
  return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 915));
};

var Questions = function Questions() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 799));
};
var Paper = function Paper() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 798));
};
var Courseware = function Courseware() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 797));
};
var Course = function Course() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 796));
};
var Train = function Train() {
  return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 830));
};
var Traintask = function Traintask() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 832));
};
var RegulatorTrainTask = function RegulatorTrainTask() {
  return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 829));
};
var trainingMaterials = function trainingMaterials() {
  return __webpack_require__.e/* import() */(164).then(__webpack_require__.bind(null, 833));
};
var TrainTaskDetail = function TrainTaskDetail() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 831));
};

var safetyTrainingProgramList = function safetyTrainingProgramList() {
  return __webpack_require__.e/* import() */(123).then(__webpack_require__.bind(null, 948));
};
var trainingTask = function trainingTask() {
  return __webpack_require__.e/* import() */(122).then(__webpack_require__.bind(null, 949));
};
var latojaManagement = function latojaManagement() {
  return __webpack_require__.e/* import() */(124).then(__webpack_require__.bind(null, 947));
};

var myExam = function myExam() {
  return __webpack_require__.e/* import() */(126).then(__webpack_require__.bind(null, 944));
};
var myTrain = function myTrain() {
  return __webpack_require__.e/* import() */(125).then(__webpack_require__.bind(null, 945));
};

var ent = function ent() {
  return __webpack_require__.e/* import() */(127).then(__webpack_require__.bind(null, 920));
};

var Login = function Login(resolve) {
  return __webpack_require__.e/* require */(113).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(879)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var schoolLogin = function schoolLogin(resolve) {
  return __webpack_require__.e/* require */(108).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(941)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var workplanTable = function workplanTable() {
  return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 919));
};

var WorkStatistics = function WorkStatistics() {
  return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 908));
};
var UserStatistics = function UserStatistics() {
  return __webpack_require__.e/* import() */(139).then(__webpack_require__.bind(null, 905));
};
var VehicleStatistics = function VehicleStatistics() {
  return __webpack_require__.e/* import() */(138).then(__webpack_require__.bind(null, 906));
};
var RiskStatistics = function RiskStatistics() {
  return __webpack_require__.e/* import() */(141).then(__webpack_require__.bind(null, 903));
};
var PotentialStatistics = function PotentialStatistics() {
  return __webpack_require__.e/* import() */(142).then(__webpack_require__.bind(null, 902));
};
var AccidentStatistics = function AccidentStatistics() {
  return __webpack_require__.e/* import() */(145).then(__webpack_require__.bind(null, 899));
};
var SafetyMeetingStatistics = function SafetyMeetingStatistics() {
  return __webpack_require__.e/* import() */(140).then(__webpack_require__.bind(null, 904));
};
var VehicleViolationStatistics = function VehicleViolationStatistics() {
  return __webpack_require__.e/* import() */(137).then(__webpack_require__.bind(null, 907));
};
var LogbookWeekStatictis = function LogbookWeekStatictis() {
  return __webpack_require__.e/* import() */(143).then(__webpack_require__.bind(null, 901));
};
var LogbookMonthStatictis = function LogbookMonthStatictis() {
  return __webpack_require__.e/* import() */(144).then(__webpack_require__.bind(null, 900));
};

var shipStatistics = function shipStatistics() {
  return __webpack_require__.e/* import() */(136).then(__webpack_require__.bind(null, 909));
};

var EnterpriseUploadFile = function EnterpriseUploadFile() {
  return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 881));
};
var EnterpriseUploadDetailFile = function EnterpriseUploadDetailFile() {
  return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 880));
};

var DrivingLine = function DrivingLine() {
  return __webpack_require__.e/* import() */(150).then(__webpack_require__.bind(null, 828));
};
var AddDrivingLine = function AddDrivingLine() {
  return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, 827));
};

var FinancePayCategory = function FinancePayCategory() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 806));
};
var FinancePayDetail = function FinancePayDetail() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 807));
};
var FinancePayDetailMonthStatistics = function FinancePayDetailMonthStatistics() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 808));
};
var FinancePayDetailYearStatistics = function FinancePayDetailYearStatistics() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 809));
};
var FinanceBalanceMonth = function FinanceBalanceMonth() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 804));
};
var FinanceBalanceYear = function FinanceBalanceYear() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 805));
};
var FinancePayManagement = function FinancePayManagement() {
  return __webpack_require__.e/* import() */(162).then(__webpack_require__.bind(null, 869));
};

var SocialSupervision = function SocialSupervision() {
  return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 852));
};

var PotentialTreatment = function PotentialTreatment() {
  return __webpack_require__.e/* import() */(161).then(__webpack_require__.bind(null, 890));
};

var PotentialTroubleshooting = function PotentialTroubleshooting() {
  return __webpack_require__.e/* import() */(160).then(__webpack_require__.bind(null, 891));
};

var RiskManagement = function RiskManagement() {
  return __webpack_require__.e/* import() */(159).then(__webpack_require__.bind(null, 896));
};

var ShipManagement = function ShipManagement() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 897));
};

var WWAnnouncementRecord = function WWAnnouncementRecord() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 918));
};

var voyageLog = function voyageLog() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 953));
};

var safetyProductionCost = function safetyProductionCost() {
  return __webpack_require__.e/* import() */(155).then(__webpack_require__.bind(null, 939));
};

var voyageSelfChecking = function voyageSelfChecking() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 954));
};

var maintenanceRecord = function maintenanceRecord() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 931));
};

var maritimeAffairsRecord = function maritimeAffairsRecord() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 932));
};

var telNoticeRecord = function telNoticeRecord() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 946));
};

var violationRecord = function violationRecord() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 952));
};

var productionAccident = function productionAccident() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 935));
};

var relatedPartyAccidents = function relatedPartyAccidents() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 938));
};

var healthRecords = function healthRecords() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 927));
};

var occupationalDiseaseHazards = function occupationalDiseaseHazards() {
  return __webpack_require__.e/* import() */(156).then(__webpack_require__.bind(null, 934));
};

var protectiveEquipment = function protectiveEquipment() {
  return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 937));
};

var workInjuryInsurance = function workInjuryInsurance() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 955));
};

var productionStatistics = function productionStatistics() {
  return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 936));
};

var certManage = function certManage() {
  return __webpack_require__.e/* import() */(157).then(__webpack_require__.bind(null, 921));
};
var shipCert = function shipCert() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 794));
};
var userCert = function userCert() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 795));
};

var equipmentFacilitiesManage = function equipmentFacilitiesManage() {
  return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 924));
};

var shipEquipmentFacilities = function shipEquipmentFacilities() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 943));
};

var emergencyEquipment = function emergencyEquipment() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 923));
};

var noticeAnnouncement = function noticeAnnouncement() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 933));
};

var contentsOfShipInspection = function contentsOfShipInspection() {
  return __webpack_require__.e/* import() */(133).then(__webpack_require__.bind(null, 922));
};

var shipCheck = function shipCheck() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 942));
};
var WorkticketManagement = function WorkticketManagement() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 877));
};
var JobTemplateSettings = function JobTemplateSettings() {
  return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 874));
};
var SafetyMeasures = function SafetyMeasures() {
  return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 791));
};
var ProcessInspection = function ProcessInspection() {
  return __webpack_require__.e/* import() */(118).then(__webpack_require__.bind(null, 875));
};
var JobFlow = function JobFlow() {
  return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 873));
};
var interestedParties = function interestedParties() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 928));
};
var MonitoringConfiguration = function MonitoringConfiguration() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 950));
};
var videoSurveillance = function videoSurveillance() {
  return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 951));
};

var Equipments = function Equipments() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 863));
};
var Facilities = function Facilities() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 864));
};
var DeviceTypeSettings = function DeviceTypeSettings() {
  return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 862));
};
var equipmentTypeSettings = function equipmentTypeSettings() {
  return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 867));
};
var Inspectionrecord = function Inspectionrecord() {
  return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 865));
};
var Maintenance = function Maintenance() {
  return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 866));
};
var ViewDetails = function ViewDetails() {
  return __webpack_require__.e/* import() */(128).then(__webpack_require__.bind(null, 876));
};

var RiskIdentification = function RiskIdentification() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 893));
};

var JobSetting = function JobSetting() {
  return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 930));
};
var JobRecord = function JobRecord() {
  return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 929));
};

var PerformInspectionConfig = function PerformInspectionConfig() {
  return __webpack_require__.e/* import() */(148).then(__webpack_require__.bind(null, 885));
};

_vue2.default.use(_vueRouter2.default);
var router = new _vueRouter2.default({
  mode: 'hash',
  routes: [{
    path: '/schoolLogin',
    name: '登录',
    component: schoolLogin
  }, {
    path: '/login',
    name: '登录',
    component: Login
  }, {
    path: '/404',
    name: 'notFound',
    component: notFound
  }, {
    path: '/401',
    name: 'notPermission',
    component: notPermission
  }, {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/dashboard',
    leaf: true,
    menuShow: true,
    iconCls: 'fa fa-home',
    children: [{ path: '/dashboard', component: Dashboard, name: '首页', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '事故隐患',
    menuShow: true,
    leaf: true,
    children: [{ path: '/potential-check-table', component: PotentialCheckTable, name: '检查表管理', menuShow: true }, { path: '/potential-check-plan', component: PotentialCheckPlan, name: '检查计划', menuShow: true }, { path: '/potential-check', component: potentialCheck, name: '隐患检查', menuShow: true }, { path: '/PotentialRectificationPre', component: PotentialRectificationPre, name: ' 隐患整改', menuShow: true }, { path: '/PotentialReexaminePre', component: potentialReview, name: '隐患复查', menuShow: true }, { path: '/potential-record', component: potentialRecord, name: '隐患记录', menuShow: true }, { path: '/potential-danger-record', component: potentialDangerRecord, name: '排查隐患记录', menuShow: true }, { path: '/PotentialExaminationPre', component: PotentialExaminationPre, name: '隐患审核', menuShow: true }, { path: '/PotentialAssignmentPre', component: PotentialAssignmentPre, name: '隐患下发', menuShow: true }, { path: '/PotentialApplyCancelPre', component: PotentialApplyCancelPre, name: '隐患销号', menuShow: true }, { path: '/PotentialFilePre', component: PotentialFilePre, name: '隐患归档', menuShow: true }, { path: '/potential-check-record', component: potentialCheckRecord, name: '检查记录', menuShow: true }, { path: '/PotentialTreatment', component: PotentialTreatment, name: '隐患治理', menuShow: true }, { path: '/PotentialTroubleshooting', component: PotentialTroubleshooting, name: '隐患排查', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '积分管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Integralset', component: Integralset, name: '积分设置', menuShow: true }, { path: '/Integralist', component: Integralist, name: '积分列表', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '日志管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Logbook', component: Logbook, name: '行车日志', menuShow: true }, { path: '/MonthSafelyCheck', component: MonthSafelyCheck, name: '月度安全检查', menuShow: true }, { path: '/Assess', component: Assess, name: '心理评测', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '安全例会管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/MeetTable', component: MeetTable, name: '安全例会', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '动态监管',
    menuShow: true,
    leaf: true,
    children: [{ path: '/VehicleLocation', component: VehicleLocation, name: '车辆定位信息', menuShow: true }, { path: '/VehicleWarn', component: VehicleWarn, name: '车辆报警信息', menuShow: true }, { path: '/violationList', component: violationList, name: '车辆违章记录', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '应急管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/reservePlan', component: reservePlan, name: '应急预案', menuShow: true }, { path: '/troops', component: troops, name: '应急队伍', menuShow: true }, { path: '/material', component: material, name: '应急物质', menuShow: true }, { path: '/drill', component: drill, name: '应急演练', menuShow: true }, { path: '/emergencyManagement', component: emergencyManagement, name: '应急管理', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '学习园地管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Study', component: Study, name: '学习园地', menuShow: true }, { path: '/technicalnorm', component: technicalnorm, name: '技术规范', menuShow: true }, { path: '/law', component: law, name: '法律法规', menuShow: true }, { path: '/accidentcases', component: accidentcases, name: '典型事故案例', menuShow: true }, { path: '/studyManagement', component: studyManagement, name: '学习园地管理', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '企业管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/EnterpriseInfo', component: EnterpriseInfo, name: '企业信息', menuShow: true }, { path: '/EnterpriseData', component: EnterpriseData, name: '企业信息', menuShow: true }, { path: '/ServiceUnit', component: ServiceUnit, name: '服务单位', menuShow: true }, { path: '/SchoolVehicle', component: SchoolVehicle, name: '车辆档案', menuShow: true }, { path: '/SchoolVehicleInsurance', component: SchoolVehicleInsurance, name: '车辆保险', menuShow: true }, { path: '/SchoolVideoMonitor', component: SchoolVideoMonitor, name: '视频监控', menuShow: true }, { path: '/SchoolVehicleRepairRecord', component: SchoolVehicleRepairRecord, name: '维修记录', menuShow: true }, { path: '/Driver', component: Driver, name: '驾驶员档案', menuShow: true }, { path: '/SafetyPerson', component: SafetyPerson, name: '安全管理 相关安全负责人', menuShow: true }, { path: '/MonitorPerson', component: MonitorPerson, name: '安全管理 专职监控人员', menuShow: true }, { path: '/NetworkDocumen', component: NetworkDocumen, name: '安全管理 安全生产管理网络图', menuShow: true }, { path: '/Escort', component: Escort, name: '押运员档案', menuShow: true }, { path: '/Stevedore', component: Stevedore, name: '装卸人员档案', menuShow: true }, { path: '/SafetyInput', component: SafetyInput, name: '安全投入', menuShow: true }, { path: '/Vehicle', component: Vehicle, name: '车辆档案', menuShow: true }, { path: '/SafetyMeeting', component: SafetyMeeting, name: '安全例会Old', menuShow: true }, { path: '/SafetyTrained', component: SafetyTrained, name: '安全培训', menuShow: true }, { path: '/Accident', component: Accident, name: '事故信息', menuShow: true }, { path: '/SpecialPersonnel', component: SpecialPersonnel, name: '特种设备作业人员', menuShow: true }, { path: '/SpecialEquipment', component: SpecialEquipment, name: '特种设备', menuShow: true }, { path: '/User', component: User, name: '用户管理', menuShow: true }, { path: '/organList', component: organList, name: '部门管理', menuShow: true }, { path: '/postList', component: postList, name: '岗位管理', menuShow: true }, { path: '/archives/ent', component: ent, name: '一企一档', menuShow: true }, { path: '/FileSign', component: FileSign, name: '文件签字管理', menuShow: true }, { path: '/PreMeetingSign', component: PreMeetingSign, name: '班前会', menuShow: true }, { path: '/UserRewardsPunishmentRecord', component: UserRewardsPunishmentRecord, name: '奖惩记录', menuShow: true }, { path: '/UserHomeVisitRecord', component: UserHomeVisitRecord, name: '家访记录', menuShow: true }, { path: '/SocialSupervision', component: SocialSupervision, name: '社会监督', menuShow: true }, { path: '/ShipManagement', component: ShipManagement, name: '船舶管理', menuShow: true }, { path: '/WWAnnouncementRecord', component: WWAnnouncementRecord, name: '气象/水位通告记录', menuShow: true }, { path: '/voyageLog', component: voyageLog, name: '航行日志', menuShow: true }, { path: '/safetyProductionCost', component: safetyProductionCost, name: '安全生产费用', menuShow: true }, { path: '/voyageSelfChecking', component: voyageSelfChecking, name: '航行自检', menuShow: true }, { path: '/maintenanceRecord', component: maintenanceRecord, name: '机务工作记录', menuShow: true }, { path: '/maritimeAffairsRecord', component: maritimeAffairsRecord, name: '海务工作记录', menuShow: true }, { path: '/telNoticeRecord', component: telNoticeRecord, name: '电话通知记录', menuShow: true }, { path: '/violationRecord', component: violationRecord, name: '违法违章', menuShow: true }, { path: '/productionAccident', component: productionAccident, name: '生产事故', menuShow: true }, { path: '/relatedPartyAccidents', component: relatedPartyAccidents, name: '相关方事故', menuShow: true }, { path: '/healthRecords', component: healthRecords, name: '健康档案', menuShow: true }, { path: '/occupationalDiseaseHazards', component: occupationalDiseaseHazards, name: '职业病危害', menuShow: true }, { path: '/protectiveEquipment', component: protectiveEquipment, name: '防护用品发放记录', menuShow: true }, { path: '/workInjuryInsurance', component: workInjuryInsurance, name: '工伤保险参保台账', menuShow: true }, { path: '/productionStatistics', component: productionStatistics, name: '生产情况统计', menuShow: true }, { path: '/certManage', component: certManage, name: '证书管理', menuShow: true }, { path: '/shipCert', component: shipCert, name: '船舶证书', menuShow: true }, { path: '/userCert', component: userCert, name: '人员证书', menuShow: true }, { path: '/equipmentFacilitiesManage', component: equipmentFacilitiesManage, name: '设备设施管理', menuShow: true }, { path: '/shipEquipmentFacilities', component: shipEquipmentFacilities, name: '船舶设备设施', menuShow: true }, { path: '/emergencyEquipment', component: emergencyEquipment, name: '应急设备', menuShow: true }, { path: '/contentsOfShipInspection', component: contentsOfShipInspection, name: '船舶检查内容设置', menuShow: true }, { path: '/shipCheck', component: shipCheck, name: '船舶检查', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '体系运行',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Document', component: Document, name: '体系文件', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '风险管控',
    menuShow: true,
    leaf: true,
    children: [{ path: '/RiskUnit', component: RiskUnit, name: '风险单元', menuShow: true }, { path: '/RiskEvent', component: RiskEvent, name: '事故类型', menuShow: true }, { path: '/RiskControl', component: RiskControl, name: '风险分级管控', menuShow: true }, { path: '/Inspection', component: Inspection, name: '风险单元巡查', menuShow: true }, { path: '/RiskManagement', component: RiskManagement, name: '风险管控', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '系统管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Mail', component: Mail, name: '待办事项', menuShow: true }, { path: '/RegulatorWorkTask', component: RegulatorWorkTask, name: '工作任务', menuShow: true }, { path: '/RegulatorTrainTask', component: RegulatorTrainTask, name: '培训任务', menuShow: true }, { path: '/RegulatorPotentialTask', component: RegulatorPotentialTask, name: '隐患排查任务', menuShow: true }, { path: '/RegulatorSafetyMeetingTask', component: RegulatorSafetyMeetingTask, name: '安全例会任务', menuShow: true }, { path: '/Password', component: Password, name: '修改密码', menuShow: true }, { path: '/UserInfo', component: UserInfo, name: '用户信息', menuShow: true }, { path: '/noticeAnnouncement', component: noticeAnnouncement, name: '通知公告', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '工作计划管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/workplanTable', component: workplanTable, name: '工作计划', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '参数配置',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Sms', component: Sms, name: '短信推送', menuShow: true }, { path: '/PreExpirationConfig', component: PreExpirationConfig, name: '预过期时间配置', menuShow: true }, { path: '/PerformInspectionConfig', component: PerformInspectionConfig, name: '执行检查参数配置', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '教育培训',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Questions', component: Questions, name: '试题管理', menuShow: true }, { path: '/Paper', component: Paper, name: '试卷管理', menuShow: true }, { path: '/Courseware', component: Courseware, name: '课件管理', menuShow: true }, { path: '/Course', component: Course, name: '课程管理', menuShow: true }, { path: '/Train', component: Train, name: '培训计划', menuShow: true }, { path: '/Traintask', component: Traintask, name: '培训任务', menuShow: true }, { path: '/TrainingMaterials', component: trainingMaterials, name: '培训资料', menuShow: true }, { path: '/TrainTaskDetail', component: TrainTaskDetail, name: '培训任务详情', menuShow: true }]

  }, {
    path: '/',
    component: Home,
    name: '培训管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/trainingManagement/safetyTrainingProgramList', component: safetyTrainingProgramList, name: '安全培训计划', menuShow: true }, { path: '/trainingManagement/trainingTask', component: trainingTask, name: '培训任务实施', menuShow: true }, { path: '/trainingManagement/latojaManagement', component: latojaManagement, name: '线下培训管理', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '学员端',
    menuShow: true,
    leaf: true,
    children: [{ path: '/student/myExam', component: myExam, name: '我的考试', menuShow: true }, { path: '/student/myTrain', component: myTrain, name: '我的培训', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '统计报表',
    menuShow: true,
    leaf: true,
    children: [{ path: '/WorkStatistics', component: WorkStatistics, name: '工作情况统计表', menuShow: true }, { path: '/UserStatistics', component: UserStatistics, name: '人员统计', menuShow: true }, { path: '/VehicleStatistics', component: VehicleStatistics, name: '车辆统计', menuShow: true }, { path: '/RiskStatistics', component: RiskStatistics, name: '风险统计', menuShow: true }, { path: '/PotentialStatistics', component: PotentialStatistics, name: '隐患统计', menuShow: true }, { path: '/AccidentStatistics', component: AccidentStatistics, name: '事故统计', menuShow: true }, { path: '/SafetyMeetingStatistics', component: SafetyMeetingStatistics, name: '安全例会统计', menuShow: true }, { path: '/VehicleViolationStatistics', component: VehicleViolationStatistics, name: '车辆违章统计', menuShow: true }, { path: '/LogbookWeekStatictis', component: LogbookWeekStatictis, name: '行车日志周统计', menuShow: true }, { path: '/LogbookMonthStatictis', component: LogbookMonthStatictis, name: '行车日志月统计', menuShow: true }, { path: '/shipStatistics', component: shipStatistics, name: '船舶报表', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '车辆线路',
    menuShow: true,
    leaf: true,
    children: [{ path: '/DrivingLine', component: DrivingLine, name: '路线管理', menuShow: true }, { path: '/AddDrivingLine', component: AddDrivingLine, name: '添加路线', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '文件管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/EnterpriseUploadFile', component: EnterpriseUploadFile, name: '企业上传文件', menuShow: true }, { path: '/EnterpriseUploadDetailFile', component: EnterpriseUploadDetailFile, name: '企业上传详细文件', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '费用支出',
    menuShow: true,
    leaf: true,
    children: [{ path: '/FinancePayCategory', component: FinancePayCategory, name: '费用支出项设置', menuShow: true }, { path: '/FinancePayDetail', component: FinancePayDetail, name: '费用支出明细', menuShow: true }, { path: '/FinancePayDetailMonthStatistics', component: FinancePayDetailMonthStatistics, name: '费用支出月度台账', menuShow: true }, { path: '/FinancePayDetailYearStatistics', component: FinancePayDetailYearStatistics, name: '费用支出年度台账', menuShow: true }, { path: '/FinanceBalanceMonth', component: FinanceBalanceMonth, name: '费用月度结余', menuShow: true }, { path: '/FinanceBalanceYear', component: FinanceBalanceYear, name: '费用年度结余', menuShow: true }, { path: '/FinancePayManagement', component: FinancePayManagement, name: '费用支出管理', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '作业管理',
    menuShow: true,
    leaf: true,
    children: [{ path: '/WorkticketManagement', component: WorkticketManagement, name: '作业票管理', menuShow: true }, { path: '/JobTemplateSettings', component: JobTemplateSettings, name: '作业模板设置', menuShow: true }, { path: '/SafetyMeasures', component: SafetyMeasures, name: '安全措施' }, { path: '/ProcessInspection', component: ProcessInspection, name: '过程检查表' }, { path: '/JobFlow', component: JobFlow, name: '作业流程' }, { path: '/ViewDetails', component: ViewDetails, name: '作业流程' }, { path: '/RiskIdentification', component: RiskIdentification, name: '风险辨识库' }, { path: '/JobSetting', component: JobSetting, name: '作业模板设置', menuShow: true }, { path: '/job-record', component: JobRecord, name: '作业票管理', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '相关方',
    menuShow: true,
    leaf: true,
    children: [{ path: '/interestedParties', component: interestedParties, name: '相关方', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '视频监控',
    menuShow: true,
    leaf: true,
    children: [{ path: '/MonitoringConfiguration', component: MonitoringConfiguration, name: '监控配置', menuShow: true }, { path: '/videoSurveillance', component: videoSurveillance, name: '视频监控', menuShow: true }]
  }, {
    path: '/',
    component: Home,
    name: '设备设施',
    menuShow: true,
    leaf: true,
    children: [{ path: '/Equipments', component: Equipments, name: '设备（码头）', menuShow: true }, { path: '/Facilities', component: Facilities, name: '设施（码头）', menuShow: true }, { path: '/DeviceTypeSettings', component: DeviceTypeSettings, name: '设施类型设置', menuShow: true }, { path: '/Inspectionrecord', component: Inspectionrecord, name: '点检记录', menuShow: true }, { path: '/Maintenance', component: Maintenance, name: '保养记录', menuShow: true }, { path: '/equipmentTypeSettings', component: equipmentTypeSettings, name: '设备类型设置', menuShow: true }]
  }, {
    path: "*",
    redirect: "/404"
  }]
});

router.beforeEach(function (to, from, next) {
  var menus = _util2.default.expandMenusData();
  if (to.path.startsWith('/login')) {
    window.localStorage.removeItem('userinfo');
    next();
  } else if (!menus.includes(to.path)) {
    if (to.path == '/UserRewardsPunishmentRecord' || to.path == '/UserHomeVisitRecord') {
      next();
    } else {
      next();
    }
  } else if (to.path.startsWith('/404')) {
    next();
  } else if (to.path.includes('http')) {
    window.open(to.fullPath.substr(1));
  } else {
    var user = window.localStorage.getItem('userinfo');
    if (!user) {
      next({ path: '/login' });
    } else {
      next();
    }
  }
});

exports.default = router;

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(212);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059f4733_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(747);
function injectStyle (ssrContext) {
  __webpack_require__(724)
}
var normalizeComponent = __webpack_require__(94)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059f4733_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_custom_upload_vue__ = __webpack_require__(213);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_274a1619_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_custom_upload_vue__ = __webpack_require__(748);
function injectStyle (ssrContext) {
  __webpack_require__(725)
}
var normalizeComponent = __webpack_require__(94)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-274a1619"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_custom_upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_274a1619_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_custom_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_previewMedia_vue__ = __webpack_require__(214);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55cfb76a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_previewMedia_vue__ = __webpack_require__(749);
function injectStyle (ssrContext) {
  __webpack_require__(726)
}
var normalizeComponent = __webpack_require__(94)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55cfb76a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_previewMedia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55cfb76a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_previewMedia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 408:
/***/ (function(module, exports) {

module.exports = {"_from":"axios@^0.21.0","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"axios@^0.21.0","name":"axios","escapedName":"axios","rawSpec":"^0.21.0","saveSpec":null,"fetchSpec":"^0.21.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmmirror.com/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@^0.21.0","_where":"D:\\work\\wharf\\zt-traffic-wharf-enterprise","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _elementUi = __webpack_require__(328);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(331);

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(339);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(327);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(190);

var _store2 = _interopRequireDefault(_store);

var _constant = __webpack_require__(326);

var _constant2 = _interopRequireDefault(_constant);

var _echarts = __webpack_require__(194);

var _echarts2 = _interopRequireDefault(_echarts);

__webpack_require__(336);

__webpack_require__(330);

__webpack_require__(329);

__webpack_require__(335);

__webpack_require__(337);

var _unfold = __webpack_require__(197);

var _unfold2 = _interopRequireDefault(_unfold);

var _vue2OrgTree = __webpack_require__(345);

var _vue2OrgTree2 = _interopRequireDefault(_vue2OrgTree);

var _vueGeminiScrollbar = __webpack_require__(338);

var _vueGeminiScrollbar2 = _interopRequireDefault(_vueGeminiScrollbar);

var _vuePrintNb = __webpack_require__(342);

var _vuePrintNb2 = _interopRequireDefault(_vuePrintNb);

var _vueAmap = __webpack_require__(195);

var _vueAmap2 = _interopRequireDefault(_vueAmap);

var _vueSeamlessScroll = __webpack_require__(344);

var _vueSeamlessScroll2 = _interopRequireDefault(_vueSeamlessScroll);

var _customUpload = __webpack_require__(340);

var _customUpload2 = _interopRequireDefault(_customUpload);

var _previewMedia = __webpack_require__(341);

var _previewMedia2 = _interopRequireDefault(_previewMedia);

var _vueQuillEditor = __webpack_require__(343);

var _vueQuillEditor2 = _interopRequireDefault(_vueQuillEditor);

__webpack_require__(333);

__webpack_require__(334);

__webpack_require__(332);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

_vue2.default.component("Unfold", _unfold2.default);

_vue2.default.use(_vue2OrgTree2.default);

_vue2.default.use(_vueGeminiScrollbar2.default);

_vue2.default.use(_vuePrintNb2.default);

_vue2.default.use(_vueAmap2.default);

_vue2.default.use(_vueSeamlessScroll2.default);

_vue2.default.component("preview-media", _previewMedia2.default);
_vue2.default.component("custom-upload", _customUpload2.default);

_vueAmap2.default.initAMapApiLoader({
  key: 'f6aa4822ef075db57eaaffb737a91e64',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geolocation', 'AMap.Geocoder', 'AMap.AMapManager', 'AMap.Driving', 'AMap.DragRoute', 'AMap.Marker'],
  v: '1.4.4',
  uiVersion: '1.0' });

_vue2.default.use(_vueQuillEditor2.default);

_vue2.default.prototype.$bus = new _vue2.default();
_vue2.default.prototype.$tableStyle = {
  background: '#F0F8FF', color: '#09558f'
};
_vue2.default.config.productionTip = false;
_vue2.default.prototype.$echarts = _echarts2.default;
_vue2.default.prototype.$const = _constant2.default;
_vue2.default.prototype.$checkPhone = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
_vue2.default.prototype.$checkPhoneNew = /(1[0-9]{10})|([0-9]{3,4})?[0-9]{7,8}/g;
_elementUi2.default.Dialog.props.closeOnClickModal.default = false;

_vue2.default.use(_elementUi2.default);

_vue2.default.filter('filterscolor', function (value) {
  var str = '';
  switch (value.Status) {
    case 10:
      str = "";
      break;
    case 20:
      str = "success";
      break;
    case 21:
      str = "danger";
      break;
    case 30:
      str = "success";
      break;
    case 40:
      str = "warning";
      break;
    case 50:
      break;
    case 61:
      break;
    case 62:
      break;
    case 60:
      break;
    case 70:
      break;
  }
  return str;
});

_vue2.default.directive('dialogDrag', {
  bind: function bind(el, binding, vnode, oldVnode) {
    var dialogHeaderEl = el.querySelector('.el-dialog__header');
    var dragDom = el.querySelector('.el-dialog');

    dialogHeaderEl.style.cssText += ';cursor:move;';
    dragDom.style.cssText += ';top:0px;';

    var sty = function () {
      if (window.document.currentStyle) {
        return function (dom, attr) {
          return dom.currentStyle[attr];
        };
      } else {
        return function (dom, attr) {
          return getComputedStyle(dom, false)[attr];
        };
      }
    }();

    dialogHeaderEl.onmousedown = function (e) {
      var disX = e.clientX - dialogHeaderEl.offsetLeft;
      var disY = e.clientY - dialogHeaderEl.offsetTop;

      var screenWidth = document.body.clientWidth;
      var screenHeight = document.documentElement.clientHeight;

      var dragDomWidth = dragDom.offsetWidth;
      var dragDomheight = dragDom.offsetHeight;

      var minDragDomLeft = dragDom.offsetLeft;
      var maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

      var minDragDomTop = dragDom.offsetTop;
      var maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;

      var styL = sty(dragDom, 'left');
      var styT = sty(dragDom, 'top');

      if (styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100);
      } else {
        styL = +styL.replace(/\px/g, '');
        styT = +styT.replace(/\px/g, '');
      };

      document.onmousemove = function (e) {
        var left = e.clientX - disX;
        var top = e.clientY - disY;

        if (-left > minDragDomLeft) {
          left = -minDragDomLeft;
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }

        if (-top > minDragDomTop) {
          top = -minDragDomTop;
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop;
        }

        dragDom.style.cssText += ';left:' + (left + styL) + 'px;top:' + (top + styT) + 'px;';
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});

_vue2.default.directive('has', {
  inserted: function inserted(el, binding) {
    if (!_vue2.default.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el);
    }
  }
});

_vue2.default.directive("input-limit", {
  bind: function bind(el, binding) {
    var wins_0 = /[^\d]/g;
    var wins_1 = /[^\d^\.]/g;
    var flag = true;
    var points = 0;
    var lengths = 0;
    var remainder = 0;
    var no_int = 0;
    var target = el instanceof HTMLInputElement ? el : el.querySelector("input");
    target.addEventListener("compositionstart", function (e) {
      flag = false;
    });
    target.addEventListener("compositionend", function (e) {
      flag = true;
    });
    target.addEventListener("input", function (e) {
      setTimeout(function () {
        if (flag) {
          if (binding.value == 0) {
            if (wins_0.test(e.target.value)) {
              e.target.value = e.target.value.replace(wins_0, "");
              e.target.dispatchEvent(new Event("input"));
            }
          }
          if (binding.value == 1) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true;
            }
            if (e.target.value.split('.').length - 1 > 1) {
              points = true;
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 1) {
                lengths = true;
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false;
            } else {
              no_int = true;
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(".") + 2);
              } else {
                e.target.value = e.target.value.replace(wins_0, "");
              }
              e.target.dispatchEvent(new Event("input"));
            }
          }

          if (binding.value == 2) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true;
            }
            if (e.target.value.split('.').length - 1 > 1) {
              points = true;
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 2) {
                lengths = true;
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false;
            } else {
              no_int = true;
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(".") + 3);
              } else {
                e.target.value = e.target.value.replace(wins_0, "");
              }
              e.target.dispatchEvent(new Event("input"));
            }
          }
        }
      }, 0);
    });
  }
});

_vue2.default.prototype.$_has = function (value) {
  var isExist = false;
  var buttonpermsStr = localStorage.getItem("perms");
  if (buttonpermsStr == undefined || buttonpermsStr == null) {
    return false;
  }
  var buttonperms = JSON.parse(buttonpermsStr);
  for (var i = 0; i < buttonperms.length; i++) {
    if (buttonperms[i].authority.indexOf(value) > -1) {
      isExist = true;
      break;
    }
  }
  return isExist;
};

_vue2.default.prototype.isNormalUser = function () {
  var isNormalUser = false;
  var userinfoStr = localStorage.getItem("userinfo");
  var userinfo = JSON.parse(userinfoStr);
  return userinfo.isNormalUser;
};

_vue2.default.filter('format', function (val, arg) {
  if (!val) return;
  var pattern = 'yyyy-MM-dd';
  if (arg) {
    pattern = arg;
  }

  return new Date(val).format(pattern);
});

Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "H+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),
    "S": this.getMilliseconds() };
  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};

new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<App/>',
  components: { App: _App2.default }

});

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-upload"},[_c('el-upload',_vm._b({attrs:{"action":_vm.url(),"accept":_vm.$attrs.accept || _vm.all_suffix,"list-type":"list","before-upload":_vm.before,"on-change":function (file, fileList) {
                _vm.change(file);
            },"before-remove":function (file, fileList) {
                return _vm.before_remove(file);
            },"file-list":_vm.fileList},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,scopeSlotName){return {key:scopeSlotName,fn:function(scope){return [_vm._t(scopeSlotName,null,null,scope)]}}})],null,true)},'el-upload',_vm.$attrs,false),[_vm._l((_vm.$slots),function(_,slotName){return _vm._t(slotName,null,{"slot":slotName})})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"width":"30%","before-close":_vm.VideoClose},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{class:{mp3: _vm.mediaType === 'mp3'}},[_c('video',{ref:"playVideo",staticClass:"video_avatar",attrs:{"src":_vm.src,"controls":"controls","controlslist":"nodownload"},on:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();return (function() {return false}).apply(null, arguments)}}},[_vm._v("\n            您的浏览器不支持视频播放\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.data.length<_vm.maxLen)?_c('span',[_c('span',{staticClass:"tj"},[_vm._v(_vm._s(_vm.data))])]):_c('span',[_c('span',{staticClass:"tj"},[_vm._v(_vm._s(_vm.showBtn?_vm.sliceStr:_vm.data)+"\n      "),_c('span',{staticClass:"btnWord",on:{"click":function($event){_vm.showBtn=!_vm.showBtn}}},[_vm._v(_vm._s(_vm.showBtn?_vm.tip:"收起"))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 788:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[409]);


// WEBPACK FOOTER //
// static/js/app.f4e4df9b900de4ae118f.js